import { render, staticRenderFns } from "./BrandFilter.vue?vue&type=template&id=97370cea&scoped=true"
import script from "./BrandFilter.vue?vue&type=script&lang=js"
export * from "./BrandFilter.vue?vue&type=script&lang=js"
import style0 from "./BrandFilter.vue?vue&type=style&index=0&id=97370cea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97370cea",
  null
  
)

export default component.exports